import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "application"
}
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "col half" }
const _hoisted_7 = ["^href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["^href"]
const _hoisted_10 = { class: "col half" }

import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Actions, Mutations } from "@/store";
import { Application } from "@/models/application";
import { Note } from "@/models/note";
import { Shortcut } from "@/models/shortcut";
import ShortcutKey from "../shortcut/ShortcutKey.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Application',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const application = computed<Application>(() => store.state.application);
const notes = computed<Note[]>(() => store.state.notes);
const shortcuts = computed(() => store.state.shortcuts);

onMounted(() => {
  store.dispatch(Actions.GetApplication, route.params.id);
  store.dispatch(Actions.GetNotes);
  store.dispatch(Actions.GetShortcuts);
});

const getNotes = (ids: number[] = []) =>
  notes.value.filter((n: Note) => ids.includes(n.id));
const getShortcuts = (app: Application): Shortcut[] =>
  shortcuts.value
    .filter((s: Shortcut) => s.application_id === app.id)
    .sort((a: Shortcut, b: Shortcut) => (a.name > b.name ? 1 : -1));

const edit = () => {
  store.commit(Mutations.SetApplication, application.value);
  router.push(`/application/${application.value.id}/edit`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "buttons" }, [
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: edit
      }, [
        _hoisted_1,
        _createTextVNode(" Edit ")
      ])
    ]),
    (application.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(application.value.name)
          }, null, 8, _hoisted_3),
          _createElementVNode("p", {
            textContent: _toDisplayString(application.value.description)
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNotes(application.value.features), (note) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createElementVNode("a", {
                    "^href": `/note/${note.id}`
                  }, _toDisplayString(note.title), 9, _hoisted_7),
                  (getNotes(note.chapters).length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNotes(note.chapters), (n) => {
                          return (_openBlock(), _createElementBlock("li", null, [
                            _createElementVNode("a", {
                              "^href": `/note/${n.id}`
                            }, _toDisplayString(n.title), 9, _hoisted_9)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            ]),
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getShortcuts(application.value), (shortcut) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createVNode(ShortcutKey, { shortcut: shortcut }, null, 8, ["shortcut"])
                ]))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})